import React, { useContext, useState, useEffect } from 'react';
import { IStyleContext, StyleContext } from './styleState/styleContext';
import Sidebar from './components/Sidebar/Sidebar';
import LanguageBar from './components/LanguageBar/LanguageBar';
import StyleFields from 'components/StyleFields/StyleFields';
import MediaFields from './components/MediaFields/MediaFields';
import DocumentSettings from './components/DocumentSettings/DocumentSettings';
import BtnBlock from './components/BtnBlock/BtnBlock';
import NoData from 'components/NoResultsFound/NoData';
import ModalWindows from './components/ModalWindows/ModalWindows';
import classNames from 'classnames';
import style from './StyleForm.module.scss';

interface IStyleForm {
	isVisible: boolean;
}

const StyleForm: React.FC<IStyleForm> = ({ isVisible }) => {
	const {
		setStyleSettings,
		mediaSettingsForUpdate,
		documentSettingsForUpdate,
		selectedGroup,
		styleSettingColors,
		loading,
	} = useContext<IStyleContext>(StyleContext);
	const [isFirstEntry, setIsFirstEntry] = useState(true);
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	useEffect(() => {
		if (isFirstEntry && isVisible && loading) {
			setIsFirstEntry(false);
		}
	}, [isVisible, loading]);

	return (
		<div className={containerClasses} data-test="StyleForm">
			{mediaSettingsForUpdate.length ? (
				<>
					<div className={style.sidebar}>
						<Sidebar />
					</div>
					<div className={style.content}>
						<div className={style.languageBar}>
							<LanguageBar />
						</div>
						<>
							<div className={style.inputsWrapper}>
								<StyleFields
									selectedGroup={selectedGroup}
									setStyleSettings={setStyleSettings}
									styleSettingColors={styleSettingColors}
								/>
							</div>
							<div className={style.inputsWrapper}>
								{mediaSettingsForUpdate.map((el) => (
									<MediaFields data={el} key={el.languageId} />
								))}
							</div>
							{documentSettingsForUpdate.map((el) => (
								<div className={style.fieldsWrapper} key={el.key}>
									<DocumentSettings data={el} />
								</div>
							))}
							<BtnBlock />
						</>
					</div>
				</>
			) : (
				<>{!loading && !isFirstEntry ? <NoData /> : null}</>
			)}
			<ModalWindows />
		</div>
	);
};

export default StyleForm;
